export default "__VITE_ASSET__l6aCv$uj__"